<template>
<v-container fluid class="fullscreen">
  <v-row no-gutters>
    <v-col cols="12" md="12" class="pa-2">
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="12" md="2" class="px-2">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="fromMenu"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateValue"
                    label="From Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="fromDate" @input="fromMenu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2" class="px-2">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="toMenu"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateValue"
                    label="To Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="toDate" @input="toMenu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" class="px-2 pt-4">
             <v-autocomplete
                item-text="profileName"
                prepend-icon="group"
                :items="deliveryManList"
                v-model="delivery"
                label="Rider"
                return-object
                hide-details
                dense>
             </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="px-2 pt-4">
              <v-autocomplete
                item-text="status"
                prepend-icon="store"
                :items="listStatus"
                v-model="status"
                label="Status"
                hide-details
                return-object
                dense>
                </v-autocomplete>
            </v-col>
           
            
            <v-col cols="12" md="2" class="pt-3 px-2 text-right">
              <v-btn color="primary" @click="search" fab small depressed>
                <v-icon>search</v-icon>
              </v-btn>
              <v-btn depressed fab small class="mx-1" color="primary" outlined>
                <v-icon>help</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" class="px-2">
      <v-card>
        <v-card-title class="pa-0">
          <v-row no-gutters>
            <v-col cols="12" md="3" class="py-4 px-3">
              Rider Time Report
              <button icon type="button" v-on:click="onexport">
                <v-icon color="primary">assignment</v-icon>
              </button>
            </v-col>
            <v-col cols="12" md="9">
             <v-row no-gutters>
              <v-col cols="12" md="12"> <span class="red--text">Busy: {{ busy }}</span></v-col>
             </v-row>
             <v-row no-gutters>
              <v-col cols="12" md="12"><span class="purple--text">On Way : {{ onway }}</span></v-col>
             </v-row>
             <v-row no-gutters>
              <v-col cols="12" md="12"><span class="green--text">Free Way : {{ free }}</span></v-col>
             </v-row>
            </v-col>
            
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" class="pa-2">
      <v-row no-gutters>
        <v-col
          cols="12"
          v-if="responseData.reportList.length == 0"
          class="text-center"
        >No data available</v-col>
        <v-col
          v-for="(report, index) in responseData.reportList"
          :key="report.date + report.status + index"
          cols="12"
          md="4"
        >
          <v-card class="ma-1">
            <v-card-title class="primary white--text">
              <v-icon color="white" class="mr-2">event</v-icon>
              <h5 >{{ report.date }} 
                <span class="yellow--text" v-if="report.status == 'ASSIGNED'">( {{ report.status }} )</span>
                <span class="yellow--text" v-else-if="report.status == 'ACCEPTED'">( {{ report.status }} )</span>
                <span class = "orange--text" v-else-if="report.status == 'ORDERED'">( {{ report.status }} )</span>
                <span class = "red--text" v-else-if="report.status == 'PICKUP'">( {{ report.status }} )</span>
                <span class = "green--text" v-else-if="report.status == 'DELIVERED'">( {{ report.status }} )</span>
                <span class = "blue--text" v-else-if="report.status == 'COMPLETED'">( {{ report.status }} )</span>
                 <span class = "purple--text" v-else>( {{ report.status }} )</span>

                </h5>&nbsp;&nbsp;
                <h5>{{report.customerName}}</h5>
            </v-card-title>
            <v-card-text class="text--primary py-2">
              <v-row no-gutters>
                <v-col cols="12">{{report.serialNo}} . {{report.profileName}}</v-col>
              </v-row>
              <v-divider />
              <v-row no-gutters>
                <v-col cols="4">Restaurant</v-col>
                <v-col cols="4" class="text-center">Status</v-col>
                <v-col cols="4" class="text-center">Time</v-col>
              </v-row>
              <v-divider />
              <v-row v-for="rt in report.riderTimeList" :key="rt.userId" no-gutters>
                <v-col cols="4">{{ rt.restName }}</v-col>
                <v-col cols="4" class="text-center">{{ rt.tmpStatus }}</v-col>
                <v-col cols="4" class="text-center">{{ rt.time }}</v-col>
                
              </v-row>
              
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog v-model="detailDialog" width="300">
      <v-card>
        <v-card-title class="striped-row">Detail Information</v-card-title>
        <v-card-text>
          <div class="text--primary">
            <h3 class="mt-3 mb-3">{{ dialogData.dialogTitle }}</h3>
            <v-divider />
            <v-row no-gutters class="pa-1 emp-title">
              <v-col cols="4">Times</v-col>
              <v-col cols="4">Price</v-col>
              <v-col cols="4">DeliPrice</v-col>
            </v-row>
            <v-row
              class="list-detail"
              v-for="data in dialogData.reportList"
              :key="data.times"
              no-gutters
            >
            <v-col cols="4" v-if="data.times==0">Total Deli</v-col>
              <v-col cols="4" v-else>{{ data.times | defaultPaymentFormat }}</v-col>
              <v-col cols="4">{{ data.price | defaultPaymentFormat }}</v-col>
              <v-col cols="4">{{ data.deliPrice | defaultPaymentFormat }}</v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import accountUserService from "../service/AccountUserService";
import reportService from "../service/ReportService";
import orderService from "../service/OrderService";
import XLSX from "xlsx";
export default {
  data: () => {
    return {
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      delivery: {},
      status: "ALL",
      listStatus: [
        "ALL",
        "ASSIGNED",
        "ACCEPTED",
        "ORDERED",
        "PICKUP",
        "DELIVERED",
        "COMPLETED"
      ],
      rstatus : {},
      free : "",
      onway:"",
      busy:"",
      dateType: "date",
      datePickerType: "date",
      deliveryManList: [],
      
      responseData: {
        reportList: []
      },
      detailDialog: false,
      dialogData: {
        dialogTitle: "",
        reportList: [],
      },
    };
  },
  methods: {
     getAllDeliveryMan: function () {
      accountUserService.getAccountDeliverys().then((response) => {
        this.deliveryManList.splice(0, this.deliveryManList.length);
        this.deliveryManList.push(
          { userAccountId: 0, profileName: "ALL" },
          ...response
        );

        //this.deliveryManList.push(...response);
        //this.delivery = response[0];
        this.delivery = this.deliveryManList[0];
      });
    },

    getrStatusListMethod: function () {
     orderService.riderStatusList().then((response) => {
        this.rstatus = response;
        if(this.rstatus.busyList != undefined){
          for(let i = 0;i<this.rstatus.busyList.length;i++){
            if(i==0){
               this.busy = this.rstatus.busyList[i];
            }else{
              this.busy = this.busy + ", "+ this.rstatus.busyList[i];
            }
            
          }
        }
        if(this.rstatus.onWayList != undefined){
          for(let i = 0;i<this.rstatus.onWayList.length;i++){
            if(i==0){
               this.onway = this.rstatus.onWayList[i];
            }else{
              this.onway = this.onway + ", "+ this.rstatus.onWayList[i];
            }
            
          }
        }
        if(this.rstatus.freeWayList != undefined){
          for(let i = 0;i<this.rstatus.freeWayList.length;i++){
            if(i==0){
               this.free = this.rstatus.freeWayList[i];
            }else{
              this.free = this.free + ", "+ this.rstatus.freeWayList[i];
            }
            
          }
        }
        
      });
    },
    
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.dateType == "date") {
        // const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      } else if (this.dateType == "month") {
        // const [year, month, day] = date.split("-");
        return `${month}-${year}`;
      } else {
        // const [year, month, day] = date.split("-");
        return `${year}`;
      }
    },
   
    search: function () {
      this.responseData.reportList = this.responseData.reportList.filter(
        (v) => false
      );
      reportService
        .getRiderTimeReport(
          this.fromDateValue,
          this.toDateValue,
          this.delivery.userAccountId,
          this.status
        )
        .then((data) => {
          this.responseData.reportList.push(...data.reportList);
            
        });

    },
    clickDetail: function (report, emp) {
      reportService
        .getCompletDetailReport(
          report.reportTitle,
          report.action,
          this.city,
          this.branch,
          this.township,
          this.dateType,
          emp.userId
        )
        .then((data) => {
          this.detailDialog = true;
          let action = "";
          if (report.action == "to") {
            action = "Deliverer";
          } else if (report.action == "from") {
            action = "Collector";
          }
          this.dialogData.dialogTitle =
            report.reportTitle + " - " + emp.name + "(" + action + ")";
          this.dialogData.reportList = this.dialogData.reportList.filter(
            (v) => false
          );
          this.dialogData.reportList.push(...data);
        });
    },
    onexport() {
      var excelList = [];
      var header = {};
      header.date = "Date";
      header.status = "Status";
      header.rider = "Rider"
      header.restName = "Restaurant Name";
      header.tmpStatus = "Temp Status";
      header.time = "Time";
      excelList.push(header);

      var reportList = this.responseData.reportList;
      for (var i = 0; i < reportList.length; i++) {
        var report = reportList[i];
        var date = report.date;
        var status = report.status;
        var rider = report.profileName;

        var subReportList = report.riderTimeList;
        for (var j = 0; j < subReportList.length; j++) {
          var subReport = subReportList[j];
          var data = {};
          data.date=date;
          data.status=status;
          data.rider=rider;
          data.restName = subReport.restName;
          data.tmpStatus = subReport.tmpStatus;
          data.time = subReport.time;
          excelList.push(data);
        }
        
      }

     

      var pokemonWS = XLSX.utils.json_to_sheet(excelList, {
        skipHeader: true,
      });

      pokemonWS["!cols"] = [
        { width: 13 },
        { width: 30 },
        { width: 20 },
        { width: 30 },
        { width: 30 },
        { width: 30 },
      ];

      var workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, pokemonWS, "riderTimeReport");
      XLSX.writeFile(workbook, "riderTimeReport" + ".xlsx");
    },
  },
  filters: {
   
  },
  computed: {
    toDateValue() {
      var toDatetemp = "";
      toDatetemp = this.formatDate(this.toDate);
      return toDatetemp;
    },
    fromDateValue() {
      var fromDatetemp = "";
      fromDatetemp = this.formatDate(this.fromDate);
      return fromDatetemp;
    },
  },
  mounted: function () {
    this.getAllDeliveryMan();
    this.getrStatusListMethod();
  },
  watch: {
   
  },
};
</script>

<style scoped>
.striped-row {
  background: var(--v-primary-base);
  color: white;
  padding: 3px;
}
.emp .row div {
  padding: 2px;
}
.emp-title {
  font-weight: 400;
  font-size: 1.1em;
  background: gainsboro;
  margin-bottom: 2px;
}
.list-detail {
  font-weight: 300;
  padding: 1px;
  background: rgb(243, 243, 243);
  border-bottom: 1px solid rgb(233, 233, 233);
}
.list-detail .col {
  padding-left: 3px;
}
.fullscreen {
  height: 92vh;
}
</style>
